// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbz_a bht_a bht_q bht_j bht_wl bht_bj","ImgResponsive__img":"bbz_b bht_b bht_ql"};